var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDjango(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3561 0H9.30714V13.5227C8.04745 13.7812 6.76528 13.9146 5.47934 13.9209C1.87557 13.9172 0 12.3073 0 9.2156C0 6.2385 1.98944 4.30339 5.07297 4.30339C5.50543 4.29496 5.93705 4.34503 6.3561 4.45225V0V0ZM6.3561 6.80415C6.03527 6.69832 5.69875 6.64798 5.361 6.6553C3.87246 6.6553 3.00687 7.56554 3.00687 9.16052C3.00687 10.7138 3.83078 11.5712 5.3424 11.5712C5.68166 11.5711 6.02046 11.5463 6.3561 11.4968V6.80787V6.80415Z",
    fill: "#44B78B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9965 4.5095V11.2824C13.9965 13.6142 13.8216 14.7351 13.3095 15.7019C12.7869 16.6849 11.9324 17.4506 10.8981 17.8625L8.16064 16.5727C9.15514 16.2321 9.98807 15.535 10.4984 14.616C10.9197 13.7817 11.0529 12.8148 11.0529 10.2717V4.5095H13.9965ZM11.0499 0.0148315H14.0002V3.01277H11.0499V0.0148315Z",
    fill: "#44B78B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjango);
export default __webpack_public_path__ + "static/media/Django.a8280c199e94fd66d4769cdb91cb4335.svg";
export { ForwardRef as ReactComponent };